const format = (arg) => `${arg < 10 ? "0" : ""}${arg}`

export const getDateOutOfTimeStamp = (timestamp) => {
  let date = new Date(timestamp)
  const d = format(date.getDate())
  const m = format(date.getMonth() + 1)
  const y = format(date.getFullYear()).substring(2)

  return `${d}.${m}.${y}`
}

export const getTimeOutOfTimeStamp = (timestamp) => {
  let date = new Date(timestamp)
  const h = format(date.getHours())
  const m = format(date.getMinutes())

  return `${h}:${m}`
}

export const timePassedText = (lastRefreshDate) => {
  if (!lastRefreshDate) return "לא רוענן עדיין"

  const now = new Date()
  const lastRefresh = new Date(lastRefreshDate)
  const diffInMs = now - lastRefresh
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60))
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60))
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24))

  if (diffInMinutes < 1) {
    return "רק עכשיו"
  } else if (diffInMinutes < 60) {
    return `לפני ${diffInMinutes} דקות`
  } else if (diffInHours < 24) {
    return `לפני ${diffInHours} שעות`
  } else {
    return `לפני ${diffInDays} ימים`
  }
}
